import api from './api';

export const listKanbanBoards = async (onlyMine = false) => {
  const { data } = await api.get('/kanban-boards', {
    params: onlyMine ? { onlyMine: true } : {}
  });
  return data.boards || [];
};

export const listKanbanBoardTemplates = async () => {
  const { data } = await api.get('/kanban-boards/templates');
  return data.templates || [];
};

export const createKanbanBoard = async board => {
  const { data } = await api.post('/kanban-boards', board);
  return data;
};

export const updateKanbanBoard = async (id, board) => {
  const { data } = await api.put(`/kanban-boards/${id}`, board);
  return data;
};

export const setDefaultKanbanBoard = async id => {
  await api.put(`/kanban-boards/${id}/default`);
};

export const deleteKanbanBoard = async id => {
  await api.delete(`/kanban-boards/${id}`);
};

// Tablero elegido por última vez en este navegador
const STORAGE_KEY = 'kanbanBoardId';

export const getStoredBoardId = () => {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
};

export const storeBoardId = id => {
  try {
    localStorage.setItem(STORAGE_KEY, String(id));
  } catch {}
};

// Elige el tablero a mostrar: el pedido, el último usado o el predeterminado.
export const pickBoard = (boards, preferredId) => {
  const byId = id => boards.find(b => String(b.id) === String(id));
  return (
    (preferredId && byId(preferredId)) ||
    byId(getStoredBoardId()) ||
    boards.find(b => b.isDefault) ||
    boards[0] ||
    null
  );
};
